/*
 * Copyright (c) 2021. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by prabash on 5/07/2021.
 */

export let PermissionKeys = {
  MPI_ADD_PRODUCT: 'SURF-SEARCH-PANEL_MPI-ADD-PRODUCT',
  MBI_FLT_ADD_PRODUCT: 'SURF-SEARCH-PANEL_MBI-FLT-ADD-PRODUCT',
  INS_ADD_PRODUCT: 'SURF-SEARCH-PANEL_INS-ADD-PRODUCT',
  MBI_CRU_ADD_PRODUCT: 'SURF-SEARCH-PANEL_MBI-CRU-ADD-PRODUCT',
  TOU_ADD_PRODUCT: 'SURF-SEARCH-PANEL-TOUR-ADD-PRODUCT',
};


